import {component} from '../form/Constant'

export const noteKey = {
    type: 'type',
    preview: 'preview',
}
export const typeOptions = [
    {label: 'Unknown', value: 'unknown'},
    {label: 'Medical Notes', value: 'medical'},
    {label: 'Nurse Notes', value: 'nurse'},
    {label: 'AHP Notes', value: 'ahp'},
    {label: 'RAT', value: 'rat'},
    {label: 'Patient Review', value: 'patientPreview'},
    {label: 'Investigation Results', value: 'investigationResult'},
    {label: 'Frailty Contact', value: 'frailtyContact'},
]

export const noteList = [
    {
        key: '',
        description: (
            <p className="m-0 p-0 px-2 font-normal text-lg">
                <span className="font-bold text-darkcyan ">Notes</span> are the
                process of recording health information, symptoms, and treatment
                plans. They help doctors monitor progress and ensure appropriate
                care.
            </p>
        ),
        children: [
            {
                key: noteKey.type,
                component: component.dropdown,
                options: typeOptions,
                defaultValue: typeOptions[0].value,
            },
            {
                key: noteKey.preview,
                component: component.inputTextArea,
                required: true,
                placeholder: 'Input your preview here... (Field is requried)',
            },
        ],
    },
]

export const noteFilterList = [
    {
        key: 'noteInformation',
        children: [
            {
                key: 'types',
                component: component.multiSelect,
                options: typeOptions,
            },
        ],
    },
]
